import { cn } from '@/styles/tailwind-utils';
import { getIcon } from '@lib/icons';

interface SpecialtyServiceCardProps {
  name: string;
  icon: string | null;
  isActive: boolean;
  isPending: boolean;
  onToggle: () => void;
}

export function SpecialtyServiceCard({
  name,
  icon,
  isActive,
  isPending,
  onToggle,
}: SpecialtyServiceCardProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={isActive}
      className={cn(
        'relative flex flex-col items-center gap-3 rounded-md border-2 p-4 text-center transition-all duration-150',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2',
        isActive
          ? 'border-brand bg-brand-subtle text-brand'
          : 'border-border bg-surface text-muted-foreground hover:border-brand-light hover:text-foreground',
      )}
    >
      {isPending && (
        <span
          className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-brand text-white"
          aria-hidden="true"
        >
          <svg className="h-3 w-3 animate-spin" viewBox="0 0 24 24" fill="none">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </span>
      )}
      {isActive && !isPending && (
        <span
          className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-brand"
          aria-hidden="true"
        >
          <svg viewBox="0 0 16 16" fill="none" className="h-3 w-3">
            <path
              d="M3 8 L6.5 11.5 L13 5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
      <span className={cn('transition-colors', isActive ? 'text-brand' : 'text-muted-foreground')}>
        {getIcon(icon)}
      </span>
      <span className="text-xs font-medium leading-tight">{name}</span>
    </button>
  );
}
